export const usmle1PathModule = {
  id: "path",
  title: "Pathology",
  sections: [
    {
      type: "text",
      content:
        "Necrosis types: coagulative (ischemia), liquefactive (brain), caseous (TB), fat (pancreas).",
    },
    {
      type: "question",
      text: "Which necrosis is typical of ischemia in solid organs?",
      options: ["Liquefactive", "Coagulative", "Caseous", "Fat"],
      correct: 1,
      explanation: "Coagulative necrosis is classic for ischemia in solid organs.",
    },
  ],
};
